import { Button, IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro";

import DynamicIcon from "../../../../../../common/components/dynamic_icon";

/**
 * GenerateGedRhColumnDefinitions
 */

type Props = {
  onActionEdit: (idArquivoModulo: number | null, openState: boolean) => void;
  onActionDelete: (idArquivoModulo: number | null, openState: boolean) => void;
  onActionCopy: (idArquivoModulo: number | null, openState: boolean) => void;
  onActionVisualize: (idArquivoModulo: number) => void;
  onActionDownload: (idArquivoModulo: number) => void;
};

export const GenerateGedRhColumnDefinitions = ({
  onActionEdit,
  onActionDelete,
  onActionCopy,
  onActionDownload,
  onActionVisualize
}: Props): GridColDef[] => {
  return [
    {
      field: "descricao",
      filterable: false,
      headerName: "Nome do Arquivo",
      flex: 1,
      minWidth: 200,
      sortable: false,
      align: 'left',
    },
    {
      field: "visualizar",
      filterable: false,
      headerName: "Visualizar",
      width: 175,
      sortable: false,
      resizable: false,
      valueGetter: (_, rows) => ({
        arquivoNome: rows['nomePdf'],
        idArquivoModulo: rows['idArquivoModulo'],
      }),
      renderCell: (params) => {
        const maxSize = 20;
        const arquivoNome = params.value['arquivoNome'] as string;
        const idArquivoModulo = params.value['idArquivoModulo'] as number;

        return (
          <Button
            onMouseDown={() => onActionVisualize(idArquivoModulo)}
            sx={{
              fontSize: 11,
              paddingX: '.4rem',
              paddingY: 0,
              background: '#e6e6e6',
              borderLeft: '.3rem solid #45b6af',
              borderRadius: 0,
              color: 'black',
              fontWeight: 'normal',
              width: '9.5rem',
            }}>
            {arquivoNome && arquivoNome.length > maxSize ? `${arquivoNome.substring(0, maxSize)}...` : arquivoNome}
          </Button>
        );
      },
    },
    {
      field: "download",
      filterable: false,
      headerName: "Download",
      width: 175,
      sortable: false,
      resizable: false,
      valueGetter: (_, rows) => ({
        arquivoNome: rows['nome'],
        idArquivoModulo: rows['idArquivoModulo'],
      }),
      renderCell: (params) => {
        const maxSize = 20;
        const arquivoNome = params.value['arquivoNome'] as string;
        const idArquivoModulo = params.value['idArquivoModulo'] as number;

        return (
          <Button
            onMouseDown={() => onActionDownload(idArquivoModulo)}
            sx={{
              fontSize: 11,
              paddingX: '.4rem',
              paddingY: 0,
              background: '#e6e6e6',
              borderLeft: '.3rem solid #45b6af',
              borderRadius: 0,
              color: 'black',
              fontWeight: 'normal',
              width: '9.5rem',
            }}>
            {arquivoNome && arquivoNome.length > maxSize ? `${arquivoNome.substring(0, maxSize)}...` : arquivoNome}
          </Button>
        );
      },
    },
    {
      field: 'idArquivoModulo',
      sortable: false,
      filterable: false,
      headerName: 'Ações',
      minWidth: 100,
      renderCell: (params) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton onClick={() => onActionEdit(params.value, true)}>
              <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
            </IconButton>

            <IconButton onClick={() => onActionDelete(params.value, true)}>
              <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
            </IconButton>
          </div>
        );
      }
    },
    {
      field: 'idArquivoModuloCopia',
      sortable: false,
      filterable: false,
      headerName: 'Copiar',
      width: 65,
      valueGetter: (_, row) => row['idArquivoModulo'] as number,
      renderCell: (params) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton onClick={() => onActionCopy(params.value, true)}>
              <DynamicIcon nameIcon="ContentCopy" size={25} className="text-purple-500" />
            </IconButton>
          </div>
        );
      }
    }
  ];
}